import { useState, useEffect } from 'react'
import Store from '../Store/Store';
import getData from '../Admin/getData';

//import { motion } from "motion/react"

export default function Gallery( props ) {

	//console.log( 'Gallery', props )

	const [ index, setIndex ] = useState( 0 )
	const [ maxIndex, setMaxIndex ] = useState( 0 )

	//const [ zoomed, setZoomed ] = useState( false )
    const zoomedRowId = props.zoomedRowId
    const setZoomedRowId = props.setZoomedRowId

	const table = 'rows'
	const ordinal = props.ordinal

	const zoomed = zoomedRowId === props.id

	const [ images, setImages ] = useState( Store.get( 'images-' + table + '-' + props.id + '-' + ordinal ) || [] )

	function getImages() {
		const path = 'gallery/' + table + '/' + ordinal
		getData( path, null, d => { 
			const imagesTmp = []
			const imageRoot = 'https://carat80.com/api/image/'
			if ( d && d.hasOwnProperty( 'images' ) && d.images.length > 0 ) {
				d.images.forEach( a => {
					const imagePath = imageRoot + table + '/' + ordinal + '/' + a
					imagesTmp.push( imagePath )

					// cache
					const tmp = new Image()
	          		tmp.src = imagePath

				} )
			}
			setImages( imagesTmp )
			setMaxIndex( imagesTmp.length - 1 )
			Store.set( 'images-' + table + '-' + props.id + '-' + ordinal, imagesTmp )
		} )

	}

	useEffect(() => {
		getImages()
	}, [ table, ordinal ] ) ;


	const Zoom = props => { 
		if ( maxIndex === 0 ) return false
		return (
			<div 
	            className="material-symbols-outlined" 
	            onClick={ e => { 
	            	if ( zoomedRowId ) {
		            	document.body.style.overflow = "auto";
		            	setZoomedRowId( false ) 
	            	} else {
		            	document.body.style.overflow = "hidden";
		            	setZoomedRowId( props.id ) 
	            	}
	            } }
				style={{
					position:'absolute', padding:7, cursor:'pointer', 
					userSelect:'none', 

					bottom:!zoomed && 20, 
					left:!zoomed && 20, 

					top:zoomed && 20,
					right:zoomed && 20,

					display:zoomed ? 'block' : 'none', 
				}}
			>
				<div 
					className="gallery-browse"  
					style={{ fontSize:22, padding:7 }} 
				>
					{ zoomed ? 'close' : 'open_in_full' }
				</div>	
			</div>
		)
	}

	const Browse = props => { 
		if ( maxIndex === 0 ) return false
		return (
			<div 
	            className="material-symbols-outlined" 
	            onClick={ e => {
	            	if ( props.left ) setIndex( index > 0 ? index - 1 : maxIndex )
	            	if ( props.right ) setIndex( index < maxIndex ? index + 1 : 0 )
	            } }
				style={{
					position:'absolute', padding:7, cursor:'pointer', 
					userSelect:'none', bottom:20, right:props.left ? 70 : 20, 
					display:zoomed ? 'block' : 'none', 
				}}
			>
				<div className="gallery-browse" >
					{ props.left ? 'chevron_left' : 'chevron_right' }
				</div>	
			</div>
		)
	}

	const Hint = props => {
		if ( maxIndex === 0 ) return false
		return (
			<div
				className={ 'image-hint' } 
				style={{
					position:'absolute', 
					//left:'50%', top:'50%', 
					//transform:'translate(-50%,-50%)', 
					left:25, bottom:25, 
					display:'flex', alignItems:'center', 
					background:'#00000088', color:'#fff',
					fontSize:12, fontWeight:600,
					padding:'6px 12px',
					borderRadius:5, 
				}} 
			>
				<span 
					className="material-symbols-outlined"
					style={{ fontSize:20, paddingRight:8 }}
				>
					photo_library
				</span>
				<div>
					See photos
				</div>
			</div>
	) }

	return <>
		{/*
		*/}
		<div style={{ 
			position:'fixed', left:0, top:0, 
			width:'100vw', height:'100vh',
			background:'#000', zIndex:199,
			display:zoomed ? 'block' : 'none', 
		}}
		/>
		<div 
			className={ zoomed ? 'image-zoomed' : 'image' }  
            onClick={ e => { 
            	if ( !zoomed && maxIndex !== 0 ) { 
            		setZoomedRowId( zoomedRowId ? false : props.id ) 
	            	document.body.style.overflow = "hidden";
            	}
            } }
			style={{ 
				backgroundImage:'url(' + images[ index ] +  ')', 
				//backgroundSize: 'cover', 
				backgroundPositionY: 'center', 
				backgroundRepeat: 'no-repeat', 
				cursor:'pointer',
				...props.style
			}}
		>

			<Hint />

			<Browse left />
			<Browse right />
			<Zoom { ...props }  />

			{ zoomed && 
				<div style={{ 
					position:'fixed', bottom:23, left:0, 
					margin:10, padding:'8px 12px', borderRadius:5, 
					fontSize:12, fontWeight:500, 
					background:'#000000aa', color:"#fff",  
					borderRadius:15.15
				}} >
					{ index + 1 }
					&nbsp;&nbsp;/&nbsp;&nbsp;
					{ maxIndex + 1 }
				</div>
			}

		</div>
	</>
}
